import request from '@/utils/request';
/* 店铺管理-列表 */
export function queryTiYanDianUserPageList(data) {
  return request({
    url: '/ti/yan/dian/user/queryTiYanDianUserPageList',
    method: 'POST',
    data
  });
}
/* 店铺管理-增加 */
export function saveTiYanDianUser(data) {
  return request({
    url: '/ti/yan/dian/user/saveTiYanDianUser',
    method: 'POST',
    data
  });
}
/* 店铺管理-修改 */
export function updateTiYanDianUser(data) {
  return request({
    url: '/ti/yan/dian/user/updateTiYanDianUser',
    method: 'POST',
    data
  });
}
/* 店铺管理-修改的信息展示 */
export function fetchTiYanDianUserDetailById(data) {
  return request({
    url: '/ti/yan/dian/user/fetchTiYanDianUserDetailById',
    method: 'POST',
    data
  });
}
/* 店铺管理-删除 */
export function removeTiYanDianUserById(data) {
  return request({
    url: '/ti/yan/dian/user/removeTiYanDianUserById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/experience.js